/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ({

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__.p = window.__webpack_public_path__;

(function () {
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;

  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) {
        // .length of function is 2
        'use strict';

        if (target === null || target === undefined) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource !== null && nextSource !== undefined) {
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }

        return to;
      },
      writable: true,
      configurable: true
    });
  }
})();

window.theme = window.theme || {};
window.theme.sections = window.theme.sections || {};
window.theme.scripts = window.theme.scripts || {};
var loadedScripts = [];

function canLoadScript(self) {
  return {
    loadScript: function loadScript(callback) {
      if (self.script === undefined) {
        // console.log("type", self.type)
        return;
      } // if (self.script.scriptSrc === undefined){
      //   console.log("undefined scriptSrc type", self.type)
      //   return
      // }
      // console.log("type check 2", self.type)


      var scriptArray = self.script; // console.log("Script array", scriptArray)

      scriptArray.forEach(function (script) {
        var scriptSrc = script.scriptSrc; // console.log("scriptSrc", scriptSrc);

        if (scriptSrc === "theme") {
          // console.log("I am a ", script.type)
          self.initScript(script);
          return;
        }

        if (loadedScripts.includes(scriptSrc)) {
          self.initScript(script);
        } else {
          loadJS(scriptSrc, function () {
            loadedScripts.push(scriptSrc);
            self.initScript(script);
          }.bind(self));
        }
      });
    }
  };
}

function canRunScript(self) {
  return {
    initScript: function initScript(scriptToInit) {
      // console.log("Script to init", scriptToInit)
      var sectionType = scriptToInit.type;
      var scriptObject = window.theme.scripts[sectionType];
      var scriptInitFn = scriptObject.init;
      var container = self.container;
      scriptInitFn(container);
    }
  };
}

function scriptBehaviors(self) {
  return Object.assign({}, canRunScript(self), canLoadScript(self));
}

function shopifySection(container, type, id, script) {
  var self = {
    container: container,
    type: type,
    id: id,
    script: script
  };

  function sectionThemeEditorActions(self) {
    return {
      getSectionId: function getSectionId() {
        return console.log(self.id);
      }
    };
  }

  return Object.assign(self, scriptBehaviors(self), sectionThemeEditorActions(self));
}

function getContainerAttribute(container, name) {
  var attributeData = container.getAttribute(name);
  var attributeArray = attributeData.split(" ");
  return attributeArray;
}

function createSection(data) {
  return shopifySection(data.sectionToBuild, data.sectionType, data.sectionId, data.sectionScriptSrc);
}

function getScriptSrc(sectionType) {
  var sectionTypeArray = sectionType;
  var sectionScripts = [];
  sectionTypeArray.forEach(function (item) {
    var scriptData = {
      type: item,
      scriptSrc: window.theme.scripts[item].src
    };
    sectionScripts.push(scriptData);
  });
  return sectionScripts;
}

function processSection(container) {
  var newSection;
  var sectionData = {
    sectionToBuild: container,
    sectionType: getContainerAttribute(container, "data-section-type"),
    sectionId: getContainerAttribute(container, "data-section-id")[0],
    sectionScriptSrc: getScriptSrc(getContainerAttribute(container, "data-section-type"))
  };
  newSection = createSection(sectionData);
  newSection.loadScript();
}

function targetIsSection(eventTarget) {
  return eventTarget.getAttribute('data-section-type');
}

function watchLoadEvents() {
  document.addEventListener('lazyloaded', function (e) {
    var sectionEvent = e.target;

    if (targetIsSection(sectionEvent) !== null) {
      processSection(sectionEvent);
    }

    if (sectionEvent.classList.contains('ProductImg-product-template')) {
      e.target.dispatchEvent(productImageLoaded);
    }
  });
}

var productImageLoaded = new CustomEvent('loft:ProductImage__Loaded');
var sectionManager = watchLoadEvents();

/***/ })

/******/ });